/**
 * <s-back-to-top data-threshold="400"> — shows its button (data-visible) once the page is
 * scrolled past the threshold in px, and scrolls back to the top when clicked. Smooth scrolling
 * respects prefers-reduced-motion. Hidden buttons are removed from the tab order.
 */
class SBackToTop extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    if (!this.button) return;
    this.threshold = Number(this.dataset.threshold) || 400;
    this.onScroll = () => this.update();
    this.onClick = () => {
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    };
    window.addEventListener('scroll', this.onScroll, { passive: true });
    this.button.addEventListener('click', this.onClick);
    this.update();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    this.button?.removeEventListener('click', this.onClick);
  }

  update() {
    const visible = window.scrollY > this.threshold;
    this.toggleAttribute('data-visible', visible);
    this.button.tabIndex = visible ? 0 : -1;
  }
}

if (!customElements.get('s-back-to-top')) customElements.define('s-back-to-top', SBackToTop);
